var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMahb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6794 34.798H34.3043L32.6164 30.6661H49.426L46.6794 34.798ZM36.3212 35.8819H43.7583V42.909H36.3212V35.8819ZM36.3212 54.5583H43.7583V60H36.3212V54.5583ZM45.6086 11.7951H53.0696V10.5469H46.1219M44.0515 10.5469H28.7201V11.7951H43.5232M38.6843 17.0897H33.6514L31.063 12.9543H41.9687M44.5623 12.9543H50.7267L47.9785 17.0897H42.4919M36.5989 26.0227H54.9251L52.1758 29.8386H34.8706M28.579 28.918L26.6129 26.0227H31.2358M36.0851 20.2418H29.9357L31.2244 18.2479H37.6416M41.2815 18.2479H49.8376L51.3615 20.2418H40.244M39.8911 21.2336H51.9381L54.2062 24.7062H37.2949M32.6164 24.7062H26.9394L29.2054 21.2326H35.3849",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2124 0L51.7898 0.862463L50.2592 3.05553L50.2379 3.03834L44.0138 3.61567L47.8338 4.62626L48.3456 5.78548L47.13 7.51748L45.4323 7.81677L48.1182 9.54473V7.94821L49.2917 6.36332H50.2379L52.3623 10.1236L51.3657 4.05398L51.1384 3.83609L52.792 1.5859L53.2124 0Z",
    fill: "#0077C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2115 45.4324L49.1084 43.845H27.3203L47.8347 8.96429L46.0036 7.81519L14.1719 43.9886H11.637L5.83435 53.3948H43.4479L44.1937 52.2295H30.9742L31.8026 51.2204H44.7501L45.2743 50.3494H32.5017L33.3021 49.3474H45.8868L46.3835 48.3949H34.1008L34.7662 47.4642H46.9897L47.7034 46.2989H35.7534L36.5293 45.4319L48.2115 45.4324ZM26.0581 49.4824H13.3285L46.8376 8.53559L20.8154 47.9H26.7603L26.0581 49.4824Z",
    fill: "#0077C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMahb);
export default __webpack_public_path__ + "static/media/MAHB.24f78551260ce991cc85abf480622579.svg";
export { ForwardRef as ReactComponent };